
import {
  BlockContactForm,
  BlockCta,
  BlockText,
} from '../implementations';

const mappers = {
  cta: BlockCta,
  text: BlockText,
  contact_form: BlockContactForm,
};

export default mappers;
